import { env } from '../../config';
import React, { useState, useEffect, useRef } from 'react';
import { ReactSVG } from 'react-svg';
import { Circles } from 'react-loader-spinner';
import { createAuth0User, getAuth0Users, updateAuth0User, auth0PasswordReset } from './utils';
import Switch from 'react-switch';
import { Context } from '../Context';
import constant from './constants.json';
import checkIcon from '../../images/icons/check.svg';
import plusIcon from '../../images/icons/screens/white-plus.svg';
import saveIcon from '../../images/icons/menu/save.svg';

const UsersPage = ({
    lang,
    customer
}) => {

    const [state, setState] = React.useContext(Context);
    const [users, setUsers] = useState([]);
    const [editUser, setEditUser] = useState(null);
    const [stateChanged, setStateChanged] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ sortBy: 'last_name', direction: 'asc' });

    const getUsers = async () => {
        return await getAuth0Users(customer.id);
    }

    useEffect(() => {
        getUsers().then(data => {
            setUsers(data);
        })
    }, [])    

    const fillSvgColor = (svg, stroke, fill) => {
		if (stroke || fill) {
			for (var i = 0; i < svg.children.length; i++) {
                svg.children[i].setAttribute('stroke', stroke);
				svg.children[i].setAttribute('fill', fill);
            }
		}
	}

    const formatDateDigits = (num) => {
        return num < 10 ? `0${num}` : num;
    }

    const formatDate = (dateTime) => {
        const date = dateTime ? new Date(dateTime) : null
        return date
        ? `${formatDateDigits(date.getMonth() + 1)}/${formatDateDigits(date.getDate())}/${date.getFullYear()}`
        : null
    }

    const userClicked = (user) => {
        setEditUser(user);
        setShowUserModal(true);
    }

    //Check if user has logged in longer than 3 months ago
    const checkLastLogin = (loginDateTime) => {
        if (!loginDateTime) return false;

        const loginDate = new Date(loginDateTime);
        const currentDate = new Date();
        return currentDate - loginDate > constant.STALE_ACCOUNT_TIME_LIMIT
    }

    const sortUsers = (users, { sortBy, direction }) => {
        let adminTypes = [...Object.keys(constant.ADMIN_TYPES)];

        if (sortBy === 'admin') {
            return users.sort((a, b) => {
                const isAAdmin = a?.user_metadata?.role === 'af_admin' || a?.user_metadata?.role === 'admin';
                const isBAdmin = b?.user_metadata?.role === 'af_admin' || b?.user_metadata?.role === 'admin';

                return (isAAdmin === isBAdmin || isAAdmin)
                    // If direction === 'asc', then admins are listed first and order by last name
                    ? (direction === 'asc' ? -1 : 1)
                    : (direction === 'asc' ? 1 : -1);
            });
        } else if (adminTypes.includes(sortBy)) {
            return users.sort((a, b) => {
                const isAAdmin = a?.app_metadata?.portal?.roles?.includes(sortBy);
                const isBAdmin = b?.app_metadata?.portal?.roles?.includes(sortBy);

                return (isAAdmin === isBAdmin || isAAdmin)
                    // If direction === 'asc', then admins are listed first and order by last name
                    ? (direction === 'asc' ? -1 : 1)
                    : (direction === 'asc' ? 1 : -1);
            });
        } else if (sortBy === 'created_at' || sortBy === 'last_login') {
            users.sort((a, b) => {
                let aDate = new Date(a[sortBy]);
                let bDate = new Date(b[sortBy]);

                return aDate < bDate
                    ? (direction === 'asc' ? -1 : 1)
                    : (direction === 'asc' ? 1 : -1);
            });
            return users;
        } else {
            return [...users].sort((a, b) => {
                let comparison = typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number'
                    ? a[sortBy] - b[sortBy]
                    : String(a[sortBy]).localeCompare(String(b[sortBy]));

                return direction === 'asc' ? comparison : -comparison;
            });
        }
    }

    function handleSort(column) {
        setSortConfig(prev => {
            if (prev.sortBy === column) {
                // Same column clicked soflip direction
                return {
                    sortBy: column,
                    direction: prev.direction === 'asc' ? 'desc' : 'asc'
                };
            } else {
                // New column clicked so reset to ascending
                return {
                    sortBy: column,
                    direction: 'asc'
                };
            }
        });
    }


    const userRows = users.length === 0
	? <tr className="no-users-text"><td></td><td></td><td></td><td>No customers found</td></tr>
	: sortUsers(users, sortConfig).map(user => {
		return <tr key={user?.user_id} className={`user-row`} onClick={() => userClicked(user)}>
            <td>{user?.given_name}</td>
            <td>{user?.family_name}</td>
            <td>{user?.email}</td>
            {
                state.userData.customer_id === env.ACTIONFIGURE_CUSTOMER_ID
                ? <td>{user?.user_metadata?.role === 'af_admin' ? <ReactSVG className="icon" src={checkIcon} /> : <></>}</td>
                : null
            }
            <td>{ user?.app_metadata?.portal?.roles?.includes("primaryAdmin") ? <ReactSVG className="icon" src={checkIcon} /> : <></> }</td>
            <td>{ user?.app_metadata?.portal?.roles?.includes("permissionsAdmin") ? <ReactSVG className="icon" src={checkIcon} /> : <></> }</td>
            <td>{ user?.app_metadata?.portal?.roles?.includes("usersAdmin") ? <ReactSVG className="icon" src={checkIcon} /> : <></> }</td>
            <td>{user?.user_metadata?.is_active ? 'Active' : 'Suspended'}</td>
            <td>{formatDate(user?.created_at)}</td>
            <td>{user?.user_metadata?.createdBy}</td>
            <td style={{color: checkLastLogin(user?.last_login) ? 'red' : '#000'}}>{formatDate(user?.last_login)}</td>
		</tr>
	})

	return ( 
		<div className="UsersPage">
            { showUserModal &&
                <UserModal setShowUserModal={setShowUserModal} customerId={customer.id} editUser={editUser} setEditUser={setEditUser} getUsers={getUsers} setUsers={setUsers} adminUser={state.userData} /> }
            <div className="user-actions">
                <div className="left-container">
                    <button className="open-user pure-u-1-9" onClick={() => setShowUserModal(true)}>
                        <img className="open-icon" src={plusIcon}/>
                    </button>
                    <div className="user-name pure-u-1-7">
                        <p style={{marginTop: 0, marginBottom: 0}}>{customer?.name}</p>
                        <p style={{marginTop: "0.5em"}}>{customer?.address1}</p>
                    </div>
                </div>
				<div className="user-tabs pure-u-1-2">
                    <div className={`icon-container ${stateChanged ? "changed" : ""}`} title="Save changes"  >
						<ReactSVG className="icon" src={saveIcon} beforeInjection={(svg) => stateChanged ? fillSvgColor(svg, null, '#fff') : null}/>
					</div>
				</div>
			</div>
            <div className="users-container">
                <h3>Users</h3>
                <table className="users-table">
                    <tbody>
                        <tr className="header-row">							
                            <th className="table-header sortable" onClick={() => handleSort('given_name')}>First name</th>
                            <th className="table-header sortable" onClick={() => handleSort('family_name')}>Last name</th>
                            <th className="table-header sortable" onClick={() => handleSort('email')}>Email</th>
                            {
                                state.userData.customer_id === env.ACTIONFIGURE_CUSTOMER_ID
                                ? <th className="table-header sortable" style={{textAlign: 'center'}} onClick={() => handleSort('af_admin')}>Actionfigure admin</th>
                                : <></>
                            }
                            <th className="table-header sortable" onClick={() => handleSort('primaryAdmin')}>Primary Admin</th>
                            <th className="table-header sortable" onClick={() => handleSort('permissionsAdmin')}>Permissions manager</th>
                            <th className="table-header sortable" onClick={() => handleSort('usersAdmin')}>Users Admin</th>
                            <th className="table-header sortable" onClick={() => handleSort('status')}>Status</th>
                            <th className="table-header sortable" onClick={() => handleSort('created_at')}>Created</th>
                            <th className="table-header sortable" onClick={() => handleSort('created_by')}>Created by</th>
                            <th className="table-header sortable" onClick={() => handleSort('last_login')}>Last login</th>
                        </tr>
                        {userRows}
                    </tbody>
                </table>

            </div>
		</div>
	);
}

const UserModal = ({ setShowUserModal, customerId, editUser, setEditUser, getUsers, setUsers, adminUser }) => {

    const [validateNewUser, setValidateNewUser] = useState(false);
    const [sendPasswordResetEmail, setSendPasswordResetEmail] = useState(false);

    const [user, setUser] = useState({
        email: editUser ? editUser?.email : "",
        firstName: editUser ? editUser?.given_name : "",
        lastName: editUser ? editUser?.family_name : "",
        afAdmin: editUser?.user_metadata?.role ?? null,
        roles: editUser?.app_metadata?.portal?.roles ?? [],
        customerId: customerId,
        isActive: editUser?.app_metadata?.portal?.is_active ?? true
    })
    const [loading, setLoading] = useState(false);
    const [resetStatus, setResetStatus] = useState(null);
    const hasAutoCheckedAfAdmin = useRef(false);

    const isActionfigureCustomer = () => customerId === env.ACTIONFIGURE_CUSTOMER_ID;

    useEffect(() => {
        if (!editUser && isActionfigureCustomer() && !hasAutoCheckedAfAdmin.current) {
            hasAutoCheckedAfAdmin.current = true;
            setUser(prev => ({ ...prev, afAdmin: "af_admin" }));
        }
    }, [user.email]);

    const handleSubmit = async (sendEmail = false) => {
        //This variable controls how long we wait for the update/create info to be reflected in Auth0
        const refreshAwaitTime = 3000;
        setLoading(true);

        //Edit user
        if (editUser) {
            await updateAuth0User(editUser.user_id, user, editUser)
            .then(async response => {
                //Success
                if (response.status === 200) {
                    setTimeout(async () => {
                        await getUsers().then(data => {
                            setUsers(data);
                        })
                    }, refreshAwaitTime);                    
                }
                else {
                    console.log("Could not update the user");
                }
            })
        }
        //Create user
        else {
            await createAuth0User(user)
            .then(async response => {
                //Success
                if (response.status === 201) {
                    setTimeout(async () => {
                        await getUsers().then(data => {
                            setUsers(data);
                        })
                    }, refreshAwaitTime);
                }
                else {
                    console.log("Could not create the user");
                }
            })
        }
        setTimeout(async () => {
            setLoading(false);
            setShowUserModal(false);
            setEditUser(null);  
        }, refreshAwaitTime);

        if (sendEmail) {
            await handlePasswordReset(user.email);
        }
        setSendPasswordResetEmail(false);
    }

    const handleCancel = () => {
        setShowUserModal(false);
        setEditUser(null);
    }

    const handlePasswordReset = async (email) => {
        if (!email) return;
        await auth0PasswordReset(email)
        .then(resp => {
            if (resp.status === 200) {
                setResetStatus("success");
            }
            else {
                setResetStatus('fail');
            }
        })
    }

    const validateUser = (sendEmail) => {
        setSendPasswordResetEmail(sendEmail);

        let emailParts = user.email.split("@");
        const domains = ['actionfigure.ai', 'transitscreen.com'];
        if (emailParts.length > 1 && customerId === env.ACTIONFIGURE_CUSTOMER_ID && !domains.includes(emailParts[1])) {
            setValidateNewUser(true);
        } else {
            handleSubmit(sendEmail);
        }
    }

    const getResetStatus = () => {
        return <div className="reset-container">
        {
            resetStatus === 'success'
            ? <p className="message" style={{color: 'green'}}>Password reset email sent</p>
            : resetStatus === 'fail'
            ? <p className="message" style={{color: 'red'}}>Password reset email failed</p>
            : <p style={{"visibility": "hidden"}}></p>
        }
        </div>
    }

    const getUserInputs = () => {
        return <>
            {Object.entries(constant.USER_INPUTS).map(([key, input]) => (
                <div className="input-container" key={key}>
                    <div className="pure-u-1-4">{input.label}</div>
                    <div className="pure-u-3-4">
                        <input
                            className="input"
                            onChange={(e) => setUser({...user,  [input.key]: e.target.value})}
                            value={user[input.key]}
                            disabled={!user.isActive || (key === 'email' && editUser)}
                            style={key === 'email' && editUser ? {color: "#829193"} : {}}
                        />
                    </div>
                </div>
            ))}
        </>;
    }

    const getAdminSwitches = () => {
        return <>
            {Object.entries(constant.ADMIN_TYPES).map(([key, admin]) => (
                <div className="input-container" key={key}>
                    <div className="pure-u-1-8 admin-type__switch-container">
                        <Switch
                            checked={user?.roles?.includes(admin.key) ?? false}
                            checkedIcon={false}
                            disabled={
                                !user.isActive ||
                                // Some toggles aren't available to some admins.
                                // eg. usersAdmin shouldn't be able to toggle the permissions switch.
                                admin.access.filter(role => adminUser?.roles?.includes(role)).length === 0 ||
                                (admin.key !== "primaryAdmin" && user.roles.includes("primaryAdmin"))
                            }
                            height={20}
                            onChange={(checked) => setAdminRoles(admin, checked)}
                            onColor={admin.key === "primaryAdmin"? "#FF8C4B" : "#2386EE"}
                            offColor="#CCD2D3"
                            uncheckedIcon
                            width={45}
                        />
                    </div>
                    <div className="pure-u-7-8">
                        <div className="admin-type__label">{admin.label}</div>
                        <div>{admin.description}</div>
                    </div>
                </div>
            ))}
        </>;
    }

    const setAdminRoles = (role, checked) => {
        let userRoles = [...user.roles];
        let adminRoles = Object.entries(constant.ADMIN_TYPES).map(([key, admin]) => admin.key);
        if (role.key === "primaryAdmin") {
            if (checked) {
                // Use Set so that only unique values are kept in final array
                userRoles = Array.from(new Set(userRoles.concat(adminRoles)));
            } else {
                adminRoles.forEach(adminRole => {
                    userRoles = userRoles.filter(r => r !== adminRole);
                });
            }
        } else {
            if (checked) {
                // For safety's sake, filter first, in case the key is already in the array.
                userRoles = [...userRoles.filter(r => r !== role.key), role.key];
            } else {
                userRoles = [...userRoles.filter(r => r !== role.key)];
            }
            console.log('new roles', [...userRoles]);
        }

        setUser({...user, roles: [...userRoles]});
    }

    return (
        <div className="modal-wrapper">
        {
            validateNewUser
            ? <div className="modal ValidateNewUserModal">
                <div className={`${loading ? "fade-effect" : null}`}>
                    <div style={{marginBottom: "1em"}}>
                        This user's email domain is not Actionfigure or TransitScreen. Please confirm that this user should be added to the Actionfigure admin account.
                    </div>
                    { getResetStatus() }
                    <div className="bottom-container">
                        <div className="buttons-container">
                            <button className="cancel-button" onClick={() => setValidateNewUser(false)}>Cancel</button>
                            <button className="modal-button" onClick={() => handleSubmit(sendPasswordResetEmail)}>Add user</button>
                        </div>
                    </div>
                </div>
            </div>
            : <div className={`modal CreateUserModal ${loading ? "fade-effect" : null}`}>
                <div className="modal-header">
                    <h2>{editUser ? "Edit user account" : "Create a new user account"}</h2>
                </div>
                <div className="users-options">
                    { getUserInputs() }
                    {
                        editUser
                        ? <>
                            <div className="input-container">
                                <div className="pure-u-1-4">Account Active:</div>
                                <div className="pure-u-3-4" style={{ display: "flex" }}>
                                    <Switch
                                        checked={user.isActive}
                                        checkedIcon={false}
                                        height={20}
                                        onChange={(checked) => setUser({
                                            ...user,
                                            isActive: checked
                                        })}
                                        offColor="#FD4A5C"
                                        onColor="#A5DF00"
                                        uncheckedIcon
                                        width={45}
                                    />
                                </div>
                            </div>
                        </>
                        : <></>
                    }
                    {
                        isActionfigureCustomer() &&
                        <div className="input-container">
                            <input
                                checked={user?.afAdmin === "af_admin" ?? false}
                                className="checkbox-input"
                                onChange={(e) => setUser({ ...user, afAdmin: (e.target.checked ? "af_admin" : null)})}
                                type="checkbox"
                                disabled={!user.isActive}
                            />
                            <div style={{ display: "flex", alignItems: "center", marginLeft: "1em" }}>
                                Actionfigure admin
                            </div>
                        </div>
                    }
                </div>
                <h4>Account administrator</h4>
                <div>These settings grant the user access to the Administration menu with elevated privileges to manage sensitive account configurations.</div>
                <div className="users-options admin-switches">
                    {getAdminSwitches()}
                </div>
                { getResetStatus() }
                <div className="bottom-container">
                    <div className="buttons-container">
                        <div className="cancel-button-container">
                            <button className="cancel-button" onClick={handleCancel}>Cancel</button>
                        </div>
                        <div className="create-buttons-container">
                            {
                                editUser
                                ? (<button className="reset-button" onClick={() => handlePasswordReset(editUser?.email)}>Reset Password</button>)
                                : null
                            }
                            <button className={editUser ? 'modal-button' : 'create-button'} onClick={() => editUser ? handleSubmit() : validateUser(false)}>{editUser ? 'Update user': 'Create only'}</button>
                            {
                                !editUser
                                ? (<button className="modal-button" onClick={() => validateUser(true)}>Create and invite</button>)
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        {
            loading
            ? <div className="Loading" style={{zIndex: "1000"}}>
                <Circles
                    height="80"
                    width="80"
                    color="#2386EE"
                    ariaLabel="circles-loading"
                    visible={true}
                />
            </div>
            :<></>
        }
        </div>
    )
}

export default UsersPage;
export { UserModal };
